import { Injectable } from '@angular/core';
import * as bcrypt from 'bcryptjs';

@Injectable({
  providedIn: 'root',
})
export class HashService {
  
  async hash(value: string) : Promise<string> {
    const salt = await bcrypt.genSalt(10);
    return bcrypt.hash(value,salt);
  }

  async compare(value: string, hash: string): Promise<boolean> {
    return bcrypt.compare(value,hash);
  }
}
